import { render, staticRenderFns } from "./Retention.container.vue?vue&type=template&id=694fd046&scoped=true&"
import script from "./Retention.container.vue?vue&type=script&lang=js&"
export * from "./Retention.container.vue?vue&type=script&lang=js&"
import style0 from "./Retention.container.vue?vue&type=style&index=0&id=694fd046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694fd046",
  null
  
)

export default component.exports